import axios from 'axios';
import { logger } from '../utils/logger';
import { csrfService } from './csrf';

// Attach CSRF handling to the global axios instance so legacy callers
// (components still using axios directly) automatically comply with
// the backend's CSRF protection without manual header management.
axios.interceptors.request.use(
  async (config) => {
    try {
      if (csrfService.isStateChangingMethod(config.method)) {
        config.headers = await csrfService.addTokenToHeaders(config.headers as any);
      }

      if (config.data instanceof FormData && config.headers) {
        const mutableHeaders = config.headers as Record<string, any> & { delete?: (name: string) => void };
        if (typeof mutableHeaders.delete === 'function') {
          mutableHeaders.delete('Content-Type');
        } else {
          delete mutableHeaders['Content-Type'];
        }
      }
    } catch (interceptorError) {
      logger.error('Failed to attach CSRF token to request', interceptorError);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;

    if (csrfService.isCsrfError(error) && originalRequest && !originalRequest._csrfRetry) {
      originalRequest._csrfRetry = true;
      logger.info('CSRF token invalid, fetching new token and retrying');

      try {
        await csrfService.handleCsrfError();
        return axios(originalRequest);
      } catch (retryError) {
        logger.error('Failed to retry request after CSRF error', retryError);
        return Promise.reject(retryError);
      }
    }

    return Promise.reject(error);
  }
);
